module.exports = __webpack_public_path__ + "img/mobile-app-redesign.70c70cca.jpg";